
export const countryCodeList = [
    {name: "SAUDI_ARABIA", iso: "sa", code: "966"},
    {name: "AFGHANISTAN", iso: "af", code: "93"},
    {name: "ALBANIA", iso: "al", code: "355"},
    {name: "ALGERIA", iso: "dz", code: "213"},
    {name: "AMERICAN_SAMOA", iso: "as", code: "1684"},
    {name: "ANDORRA", iso: "ad", code: "376"},
    {name: "ANDORRA", iso: "ao", code: "244"},
    {name: "ANGUILLA", iso: "ai", code: "1264"},
    {name: "ANTIGUA_AND_BARBUDA", iso: "ag", code: "1268"},
    {name: "ARGENTINA", iso: "ar", code: "54"},
    {name: "ARMENIA", iso: "am", code: "374"},
    {name: "ARUBA", iso: "aw", code: "297"},
    {name: "AUSTRALIA", iso: "au", code: "61"},
    {name: "AUSTRIA", iso: "at", code: "43"},
    {name: "AZERBAIJAN", iso: "az", code: "994"},
    {name: "BAHAMAS", iso: "bs", code: "1242"},
    {name: "BAHRAIN", iso: "bh", code: "973"},
    {name: "BANGLADESH", iso: "bd", code: "880"},
    {name: "BARBADOS", iso: "bb", code: "1246"},
    {name: "BELARUS", iso: "by", code: "375"},
    {name: "BELGIUM", iso: "be", code: "32"},
    {name: "BELIZE", iso: "bz", code: "501"},
    {name: "BENIN", iso: "bj", code: "229"},
    {name: "BERMUDA", iso: "bm", code: "1441"},
    {name: "BHUTAN", iso: "bt", code: "975"},
    {name: "BOLIVIA", iso: "bo", code: "591"},
    {name: "BOSNIA_AND_HERZEGOVINA", iso: "ba", code: "387"},
    {name: "BOTSWANA", iso: "bw", code: "267"},
    {name: "BRAZIL", iso: "br", code: "55"},
    {name: "BRITISH_INDIAN_OCEAN_TERRITORY", iso: "io", code: "246"},
    {name: "BRITISH_VIRGIN_ISLANDS", iso: "vg", code: "1284"},
    {name: "BRUNEI", iso: "bn", code: "673"},
    {name: "BULGARIA", iso: "bg", code: "359"},
    {name: "BURKINA_FASO", iso: "bf", code: "226"},
    {name: "BURUNDI", iso: "bi", code: "257"},
    {name: "CAMBODIA", iso: "kh", code: "855"},
    {name: "CAMEROON", iso: "cm", code: "237"},
    {name: "CANADA", iso: "ca", code: "1"},
    {name: "CAPE_VERDE", iso: "cv", code: "238"},
    {name: "CARIBBEAN_NETHERLANDS", iso: "bq", code: "599"},
    {name: "CAYMAN_ISLANDS", iso: "ky", code: "1345"},
    {name: "CENTRAL_AFRICAN_REPUBLIC", iso: "cf", code: "236"},
    {name: "CHAD", iso: "td", code: "235"},
    {name: "CHILE", iso: "cl", code: "56"},
    {name: "CHINA", iso: "cn", code: "86"},
    {name: "CHRISTMAS_ISLAND", iso: "cx", code: "61"},
    {name: "COCOS_KEELING_ISLANDS", iso: "cc", code: "61"},
    {name: "COLOMBIA", iso: "co", code: "57"},
    {name: "COMOROS", iso: "km", code: "269"},
    {name: "CONGO_DRC", iso: "cd", code: "243"},
    {name: "CONGO_REPUBLIC", iso: "cg", code: "242"},
    {name: "COOK_ISLANDS", iso: "ck", code: "682"},
    {name: "COSTA_RICA", iso: "cr", code: "506"},
    {name: "COTE_DIVOIRE", iso: "ci", code: "225"},
    {name: "CROATIA", iso: "hr", code: "385"},
    {name: "CUBA", iso: "cu", code: "53"},
    {name: "CURACAO", iso: "cw", code: "599"},
    {name: "CYPRUS", iso: "cy", code: "357"},
    {name: "CZECH_REPUBLIC", iso: "cz", code: "420"},
    {name: "DENMARK", iso: "dk", code: "45"},
    {name: "DJIBOUTI", iso: "dj", code: "253"},
    {name: "DOMINICA", iso: "dm", code: "1767"},
    {name: "DOMINICAN_REPUBLIC", iso: "do", code: "1"},
    {name: "ECUADOR", iso: "ec", code: "593"},
    {name: "EGYPT", iso: "eg", code: "20"},
    {name: "EL_SALVADOR", iso: "sv", code: "503"},
    {name: "EQUATORIAL_GUINEA", iso: "gq", code: "240"},
    {name: "ERITREA", iso: "er", code: "291"},
    {name: "ESTONIA", iso: "ee", code: "372"},
    {name: "ETHIOPIA", iso: "et", code: "251"},
    {name: "FALKLAND_ISLANDS", iso: "fk", code: "500"},
    {name: "FAROE_ISLANDS", iso: "fo", code: "298"},
    {name: "FIJI", iso: "fj", code: "679"},
    {name: "FINLAND", iso: "fi", code: "358"},
    {name: "FRANCE", iso: "fr", code: "33"},
    {name: "FRENCH_GUIANA", iso: "gf", code: "594"},
    {name: "FRENCH_POLYNESIA", iso: "pf", code: "689"},
    {name: "GABON", iso: "ga", code: "241"},
    {name: "GAMBIA", iso: "gm", code: "220"},
    {name: "GEORGIA", iso: "ge", code: "995"},
    {name: "GERMANY", iso: "de", code: "49"},
    {name: "GHANA", iso: "gh", code: "233"},
    {name: "GIBRALTAR", iso: "gi", code: "350"},
    {name: "GREECE", iso: "gr", code: "30"},
    {name: "GREENLAND", iso: "gl", code: "299"},
    {name: "GRENADA", iso: "gd", code: "1473"},
    {name: "GUADELOUPE", iso: "gp", code: "590"},
    {name: "GUAM", iso: "gu", code: "1671"},
    {name: "GUATEMALA", iso: "gt", code: "502"},
    {name: "GUERNSEY", iso: "gg", code: "44"},
    {name: "GUINEA", iso: "gn", code: "224"},
    {name: "GUINEABISSAU", iso: "gw", code: "245"},
    {name: "GUYANA", iso: "gy", code: "592"},
    {name: "HAITI", iso: "ht", code: "509"},
    {name: "HONDURAS", iso: "hn", code: "504"},
    {name: "HONG_KONG", iso: "hk", code: "852"},
    {name: "HUNGARY", iso: "hu", code: "36"},
    {name: "ICELAND", iso: "is", code: "354"},
    {name: "INDIA", iso: "in", code: "91"},
    {name: "INDONESIA", iso: "id", code: "62"},
    {name: "IRAN", iso: "ir", code: "98"},
    {name: "IRAQ", iso: "iq", code: "964"},
    {name: "IRELAND", iso: "ie", code: "353"},
    {name: "ISLE_OF_MAN", iso: "im", code: "44"},
    {name: "ISRAEL", iso: "il", code: "972"},
    {name: "ITALY", iso: "it", code: "39"},
    {name: "JAMAICA", iso: "jm", code: "1876"},
    {name: "JAPAN", iso: "jp", code: "81"},
    {name: "JERSEY", iso: "je", code: "44"},
    {name: "JORDAN", iso: "jo", code: "962"},
    {name: "KAZAKHSTAN", iso: "kz", code: "7"},
    {name: "KENYA", iso: "ke", code: "254"},
    {name: "KIRIBATI", iso: "ki", code: "686"},
    {name: "KOSOVO", iso: "xk", code: "383"},
    {name: "KUWAIT", iso: "kw", code: "965"},
    {name: "KYRGYZSTAN", iso: "kg", code: "996"},
    {name: "LAOS", iso: "la", code: "856"},
    {name: "LATVIA", iso: "lv", code: "371"},
    {name: "LEBANON", iso: "lb", code: "961"},
    {name: "LESOTHO", iso: "ls", code: "266"},
    {name: "LIBERIA", iso: "lr", code: "231"},
    {name: "LIBYA", iso: "ly", code: "218"},
    {name: "LIECHTENSTEIN", iso: "li", code: "423"},
    {name: "LITHUANIA", iso: "lt", code: "370"},
    {name: "LUXEMBOURG", iso: "lu", code: "352"},
    {name: "MACAU", iso: "mo", code: "853"},
    {name: "MACEDONIA", iso: "mk", code: "389"},
    {name: "MADAGASCAR", iso: "mg", code: "261"},
    {name: "MALAWI", iso: "mw", code: "265"},
    {name: "MALAYSIA", iso: "my", code: "60"},
    {name: "MALDIVES", iso: "mv", code: "960"},
    {name: "MALI", iso: "ml", code: "223"},
    {name: "MALTA", iso: "mt", code: "356"},
    {name: "MARSHALL_ISLANDS", iso: "mh", code: "692"},
    {name: "MARTINIQUE", iso: "mq", code: "596"},
    {name: "MAURITANIA", iso: "mr", code: "222"},
    {name: "MAURITIUS", iso: "mu", code: "230"},
    {name: "MAYOTTE", iso: "yt", code: "262"},
    {name: "MEXICO", iso: "mx", code: "52"},
    {name: "MICRONESIA", iso: "fm", code: "691"},
    {name: "MOLDOVA", iso: "md", code: "373"},
    {name: "MONACO", iso: "mc", code: "377"},
    {name: "MONGOLIA", iso: "mn", code: "976"},
    {name: "MONTENEGRO", iso: "me", code: "382"},
    {name: "MONTSERRAT", iso: "ms", code: "1664"},
    {name: "MOROCCO", iso: "ma", code: "212"},
    {name: "MOZAMBIQUE", iso: "mz", code: "258"},
    {name: "MYANMAR_BURMA", iso: "mm", code: "95"},
    {name: "NAMIBIA", iso: "na", code: "264"},
    {name: "NAURU", iso: "nr", code: "674"},
    {name: "NEPAL", iso: "np", code: "977"},
    {name: "NETHERLANDS", iso: "nl", code: "31"},
    {name: "NEW_CALEDONIA", iso: "nc", code: "687"},
    {name: "NEW_ZEALAND", iso: "nz", code: "64"},
    {name: "NICARAGUA", iso: "ni", code: "505"},
    {name: "NIGER", iso: "ne", code: "227"},
    {name: "NIGERIA", iso: "ng", code: "234"},
    {name: "NIUE", iso: "nu", code: "683"},
    {name: "NORFOLK_ISLAND", iso: "nf", code: "672"},
    {name: "NORTH_KOREA", iso: "kp", code: "850"},
    {name: "NORTHERN_MARIANA_ISLANDS", iso: "mp", code: "1670"},
    {name: "NORWAY", iso: "no", code: "47"},
    {name: "OMAN", iso: "om", code: "968"},
    {name: "PAKISTAN", iso: "pk", code: "92"},
    {name: "PALAU", iso: "pw", code: "680"},
    {name: "PALESTINE", iso: "ps", code: "970"},
    {name: "PANAMA", iso: "pa", code: "507"},
    {name: "PAPUA_NEW_GUINEA", iso: "pg", code: "675"},
    {name: "PARAGUAY", iso: "py", code: "595"},
    {name: "PERU", iso: "pe", code: "51"},
    {name: "PHILIPPINES", iso: "ph", code: "63"},
    {name: "POLAND", iso: "pl", code: "48"},
    {name: "PORTUGAL", iso: "pt", code: "351"},
    {name: "PUERTO_RICO", iso: "pr", code: "1"},
    {name: "QATAR", iso: "qa", code: "974"},
    {name: "REUNION", iso: "re", code: "262"},
    {name: "ROMANIA", iso: "ro", code: "40"},
    {name: "RUSSIA", iso: "ru", code: "7"},
    {name: "RWANDA", iso: "rw", code: "250"},
    {name: "SAINT_BARTHELEMY", iso: "bl", code: "590"},
    {name: "SAINT_HELENA", iso: "sh", code: "290"},
    {name: "SAINT_KITTS_AND_NEVIS", iso: "kn", code: "1869"},
    {name: "SAINT_LUCIA", iso: "lc", code: "1758"},
    {name: "SAINT_MARTIN", iso: "mf", code: "590"},
    {name: "SAINT_PIERRE_AND_MIQUELON", iso: "pm", code: "508"},
    {name: "SAINT_VINCENT_AND_THE_GRENADINES", iso: "vc", code: "1784"},
    {name: "SAMOA", iso: "ws", code: "685"},
    {name: "SAN_MARINO", iso: "sm", code: "378"},
    {name: "SAO_TOME_AND_PRINCIPE", iso: "st", code: "239"},
    {name: "SENEGAL", iso: "sn", code: "221"},
    {name: "SERBIA", iso: "rs", code: "381"},
    {name: "SEYCHELLES", iso: "sc", code: "248"},
    {name: "SIERRA_LEONE", iso: "sl", code: "232"},
    {name: "SINGAPORE", iso: "sg", code: "65"},
    {name: "SINT_MAARTEN", iso: "sx", code: "1721"},
    {name: "SLOVAKIA", iso: "sk", code: "421"},
    {name: "SLOVENIA", iso: "si", code: "386"},
    {name: "SOLOMON_ISLANDS", iso: "sb", code: "677"},
    {name: "SOMALIA", iso: "so", code: "252"},
    {name: "SOUTH_AFRICA", iso: "za", code: "27"},
    {name: "SOUTH_KOREA", iso: "kr", code: "82"},
    {name: "SOUTH_SUDAN", iso: "ss", code: "211"},
    {name: "SPAIN", iso: "es", code: "34"},
    {name: "SRI_LANKA", iso: "lk", code: "94"},
    {name: "SUDAN", iso: "sd", code: "249"},
    {name: "SURINAME", iso: "sr", code: "597"},
    {name: "SVALBARD_AND_JAN_MAYEN", iso: "sj", code: "47"},
    {name: "SWAZILAND", iso: "sz", code: "268"},
    {name: "SWEDEN", iso: "se", code: "46"},
    {name: "SWITZERLAND", iso: "ch", code: "41"},
    {name: "SYRIA", iso: "sy", code: "963"},
    {name: "TAIWAN", iso: "tw", code: "886"},
    {name: "TAJIKISTAN", iso: "tj", code: "992"},
    {name: "TANZANIA", iso: "tz", code: "255"},
    {name: "THAILAND", iso: "th", code: "66"},
    {name: "TIMORLESTE", iso: "tl", code: "670"},
    {name: "TOGO", iso: "tg", code: "228"},
    {name: "TOKELAU", iso: "tk", code: "690"},
    {name: "TONGA", iso: "to", code: "676"},
    {name: "TRINIDAD_AND_TOBAGO", iso: "tt", code: "1868"},
    {name: "TUNISIA", iso: "tn", code: "216"},
    {name: "TURKEY", iso: "tr", code: "90"},
    {name: "TURKMENISTAN", iso: "tm", code: "993"},
    {name: "TURKS_AND_CAICOS_ISLANDS", iso: "tc", code: "1649"},
    {name: "TUVALU", iso: "tv", code: "688"},
    {name: "US_VIRGIN_ISLANDS", iso: "vi", code: "1340"},
    {name: "UGANDA", iso: "ug", code: "256"},
    {name: "UKRAINE", iso: "ua", code: "380"},
    {name: "UNITED_ARAB_EMIRATES", iso: "ae", code: "971"},
    {name: "UNITED_KINGDOM", iso: "gb", code: "44"},
    {name: "UNITED_STATES", iso: "us", code: "1"},
    {name: "URUGUAY", iso: "uy", code: "598"},
    {name: "UZBEKISTAN", iso: "uz", code: "998"},
    {name: "VANUATU", iso: "vu", code: "678"},
    {name: "VATICAN_CITY", iso: "va", code: "39"},
    {name: "VENEZUELA", iso: "ve", code: "58"},
    {name: "VIETNAM", iso: "vn", code: "84"},
    {name: "WALLIS_AND_FUTUNA", iso: "wf", code: "681"},
    {name: "WESTERN_SAHARA", iso: "eh", code: "212"},
    {name: "YEMEN", iso: "ye", code: "967"},
    {name: "ZAMBIA", iso: "zm", code: "260"},
    {name: "ZIMBABWE", iso: "zw", code: "263"},
    {name: "ALAND_ISLANDS", iso: "ax", code: "358"}
];


// WEBPACK FOOTER //
// ./src/app/helpers/country-code.js